export const AUTH_ERROR_CODE = {
  UNAUTHENTICATED: "UNAUTHENTICATED",
} as const;

const SESSION_REQUIRED_ROUTE_PREFIXES = ["/booking"];

export const isSessionRequiredRoute = (pathname: string): boolean =>
  SESSION_REQUIRED_ROUTE_PREFIXES.some((prefix) => pathname.startsWith(prefix));
